import { SectieBuilder } from "./sectieBuilder";

export class PdfRequestBuilder {
  private readonly secties: SectieBuilder[] = [];

  addSectie(titel: string): SectieBuilder {
    const sectieBuilder = new SectieBuilder(titel);

    this.secties.push(sectieBuilder);

    return sectieBuilder;
  }

  build() {
    return this.secties;
  }
}
